import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectSenderOnTopOption')(function selectSenderOnTopOption(senderOnTop, state) {
    var optionState = state.optionState;
    optionState.showSenderOnTopInListView = senderOnTop;
}));
//# sourceMappingURL=selectSenderOnTopOption.js.map